<template>
  <div class="window add-new-contact-window contact-window" v-show="addressKey != null">
    <span class="close" title="Закрыть" @click="clearData"><img src="../image/cancel.svg"></span>
    <div class="window-title">{{ title }}</div>
    <div class="form">
      <div class="title" v-show="showDeleteButton">
        <span class="delete" @click="deleteData"><i class="fa fa-trash-o"></i>Удалить</span>
      </div>
      <div class="form-block">
        <div class="fieldset">
          <label class="fieldset-title">Имя</label>
          <fieldset><input type="text" value="" v-model="contactPersonTempName"></fieldset>
        </div>
        <div class="fieldset">
          <label class="fieldset-title">Телефон</label>
          <fieldset><input type="text" value=""
                           v-mask="'+7 (###) ###-##-##'"
                           placeholder="'+7 (___) ___ - __ - __"
                           v-model="contactPersonTempPhone"></fieldset>
        </div>
      </div>
      <div class="buttons">
        <button type="button" class="cancel-button" @click="clearData">Отмена</button>
        <button type="button" class="save-button" @click="save">Сохранить</button>
      </div>
    </div>
  </div>
</template>

<script>
    import {EventBus} from '@/event-bus.js'
    import {mask} from 'vue-the-mask'
    import utils from '@/utils'

    export default {
  name: 'AddressContactPerson',

  directives: { mask },

  data () {
    return {
      addressKey: null,
      contactPersonTempName: null,
      contactPersonTempPhone: null,
      changeShadowVisibility: true,

      showDeleteButton: false
    }
  },

  watch: {
    addressKey (val) {
      if (val) { this.doChangeShadowVisibility(val) }
    }
  },

  created () {
    EventBus.$on('edit-address-contact', payload => {
      this.addressKey = payload.addressKey
      this.contactPersonTempName = payload.contactPersonName
      this.contactPersonTempPhone = payload.contactPersonPhone
      this.changeShadowVisibility = !!payload.changeShadowVisibility

      this.showDeleteButton = payload.contactPersonName &&
          payload.contactPersonPhone &&
          payload.contactPersonName.length > 0 &&
          payload.contactPersonPhone.length > 0
    })
  },

  computed: {
    title () {
      if (!this.contactPersonName && !this.contactPersonPhone) { return 'Добавить контакт' } else { return 'Редактировать контакт' }
    }
  },

  methods: {
    doChangeShadowVisibility (val) {
      if (this.changeShadowVisibility) { utils.changeShadowVisibility(!!val) }
    },

    save () {
      EventBus.$emit('save-address-contact', {
        addressKey: this.addressKey,
        contactPersonName: this.contactPersonTempName,
        contactPersonPhone: this.contactPersonTempPhone
      })
      this.clearData()
    },

    deleteData () {
      EventBus.$emit('save-address-contact', {
        addressKey: this.addressKey,
        contactPersonName: null,
        contactPersonPhone: null
      })
      this.clearData()
    },

    clearData () {
      this.doChangeShadowVisibility(false)

      this.addressKey = null
      this.contactPersonTempName = null
      this.contactPersonTempPhone = null
      this.changeShadowVisibility = true
    }
  }
}
</script>
